import React, { Fragment, useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react/lib/agGridReact';
import { Spinner } from 'react-bootstrap';
import AG_GRID_LOCALE_IT from 'components/projects/ag-grid-translate/locale-it';

const ReusableTable = ({
  columnDefs,
  rowData,
  defaultColDef = {
    resizable: true,
    wrapText: true,
    autoHeight: true,
    flex: 1,
    suppressMovable: true,
    cellStyle: { padding: '0 0.7rem' },
  },
  optionsPagination = [
    <Fragment key='options'>
      <option defaultValue='10' key='10'>
        10
      </option>
      <option value='20' key='20'>
        20
      </option>
      <option value='50' key='50'>
        50
      </option>
      <option value='100' key='100'>
        100
      </option>
    </Fragment>,
  ],
}) => {
  const gridApiRef = useRef(null);
  const columnApiRef = useRef(null);
  const localeText = AG_GRID_LOCALE_IT;

  const onGridReady = useCallback((params) => {
    gridApiRef.current = params.api;
    columnApiRef.current = params.columnApi;
    params.api.sizeColumnsToFit();
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    params.api.sizeColumnsToFit();
  }, []);

  const onPageSizeChanged = useCallback(() => {
    if (!gridApiRef.current) return;
    let value = document.getElementById('page-size-reusable-table').value;
    gridApiRef.current.paginationSetPageSize(Number(value));
  }, []);

  return (
    <div className='row'>
      <div className='col-12' id='grid-wrapper'>
        {rowData.length > 0 ? (
          <div
            className='ag-theme-alpine projects-list-table'
            style={{ width: '100%', height: '100%' }}>
            <AgGridReact
              columnDefs={columnDefs}
              rowData={rowData}
              defaultColDef={defaultColDef}
              domLayout='autoHeight'
              tooltipShowDelay={0}
              tooltipHideDelay={2000}
              tooltipMouseTrack={true}
              onFirstDataRendered={onFirstDataRendered}
              onGridReady={onGridReady}
              // onModelUpdated={onModelUpdated}
              pagination={true}
              paginationPageSize={10}
              headerHeight={50}
              rowHeight={50}
              localeText={localeText}
            />
            <div className='d-flex justify-content-start align-items-center'>
              Progetti per pagina:&nbsp;
              <select onChange={onPageSizeChanged} id='page-size-reusable-table'>
                {optionsPagination}
              </select>
            </div>
          </div>
        ) : (
          <div className='text-center my-4'>
            <Spinner animation='border' role='status'>
              <span style={{ visibility: 'hidden' }}>Loading...</span>
            </Spinner>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReusableTable;
